<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="relative z-10" @close="closeModal">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex min-h-full justify-center p-4 text-center items-center">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-[#f9f8f6] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
              <div class="bg-[#f9f8f6] p-6 sm:p-6 lg:p-8">
                <div>
                  <div class="text-center">
                    <DialogTitle as="h3" class="text-lg md:text-2xl font-semibold leading-6 text-gray-900 text-center">
                      Select your country
                    </DialogTitle>
                    <div class="mt-6">
                      <p class="text-sm text-gray-500">
                        You're currently on the {{ locale === 'nz' ? 'New Zealand' : 'Australia/Global' }} site. Please select the correct country to view appropriate information for your region.
                      </p>
                    </div>
                    <div class="mt-6 md:flex sm:gap-6 justify-center">
                      <div>
                        <NuxtLink 
                        class="block md:inline-block border-2 border-[#e8e5de] rounded-md bg-[#f9f8f6] align-center rounded-md transition px-3.5 py-2.5 text-sm font-semibold focus:outline-none rounded-md bg-[#4d5ceb] px-5 py-2.5 cursor-pointer transition-all duration-100 ease-in z-[999]"
                        @click="makeSelection"
                        :to="$switchLocalePath('au')">
                          <img src="https://media.elker.com/6295577e-99a4-4fd4-a3ca-b8e4698eb7cc.svg" 
                          alt="Australian Flag" 
                          class="inline-block rounded-sm mr-2 w-[36px] h-auto" />
                          <span class="leading-[27px]">Australia / Global</span>
                        </NuxtLink>
                      </div>
                      <div class="mt-4 md:mt-0">
                        <NuxtLink 
                        class="block md:inline-block  border-2 border-[#e8e5de] rounded-md bg-[#f9f8f6] align-center rounded-md transition px-3.5 py-2.5 text-sm font-semibold focus:outline-none rounded-md bg-[#4d5ceb] px-5 py-2.5 cursor-pointer transition-all duration-100 ease-in z-[999]"
                        @click="makeSelection"
                        :to="$switchLocalePath('nz')">
                          <img src="https://media.elker.com/0f166801-6750-4c5f-b117-a3eb0243dede.svg" 
                          alt="New Zealand Flag" 
                          class="inline-block rounded-sm mr-2 w-[36px] h-auto" />
                          <span class="leading-[27px]">New Zealand</span>
                        </NuxtLink>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
const open = ref(true)
const { locale } = useI18n()

const userStore = useUserStore()

const closeModal = () => {
  userStore.closeCountryModal()
  open.value = false
}

const makeSelection = () => {
  open.value = false
  userStore.selectCountry()
}
</script>